import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GridOptions } from "ag-grid/main";

import { EDIT_BTN, VIEW_BTN, DOUBLE_ROW_HEADER, DELETE_BTN, DateUtility, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility, RequestVO, WpEtEnrollment } from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { AssessmentSummary,Task,WpPerson,WpReferral } from '../shared';
import { nodeChildrenAsMap } from '@angular/router/src/utils/tree';
import { AssessmentSummaryData } from '../shared/model/AssessmentSummaryData.model';

@Component({
  selector: 'app-assessment-summary',
  templateUrl: './assessment-summary.component.html',
  styleUrls: ['./assessment-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AssessmentSummaryComponent implements OnInit {
  @ViewChild('header') header: ElementRef;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  enrollment: WpEtEnrollment;
  personId: string;
  assessments: AssessmentSummaryData[] = [];
  statusMap: any;
  programMap: any;
  serverConstants: any;
  sharedData: any;
  tabIndex:any = "-1";
  programCd;
  userActionNotificationsMap: any;
  noData: Boolean = false;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  EDIT_BTN: string = EDIT_BTN;
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;

  gridOptions: GridOptions;
  gridApi:any;
  columnDefs: any;
  pdColumnDefs: any;
  //For Audit
  auditColumnDefs: any;
  context: any;

  taskStatusJson: any;
  programJson;
  addNewDisbaled = false;
  isDisabled = false;
  index:any;
  tabToNextCell:any;
  firstTime: Boolean = true;
  task = new Task();
  taskDueDates:any[];
  taskDueDatesMap:any;
  taskDueDate:any;
  providerDeterminationData: ProviderDetermination[];

  constructor(

    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private dateUtil: DateUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('ASMNT') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {

    this.dataService.globalAccess = true;
    this.index = this.dataService.getSharedDataObject().get("ASMNT").innerNavPages.find(x=> x.pageId === 'ASMSU');
    if(this.index.readOnly == true){
      this.tabIndex = "0";
    }

    console.log(this.dataService.getSharedDataObject().get('ASMNT').innerNavPages[0]);
    console.log(this.dataService.getSharedDataObject().get('ASMNT').innerNavPages[5]);

    console.log('page 1: ' +  this.dataService.getSharedDataObject().get('ASMNT').innerNavPages[0]);
    console.log('page 2: ' +  this.dataService.getSharedDataObject().get('ASMNT').innerNavPages[1]);


    const programs = this.data.getValueFromSharedDataMap("PROGRAMS");
    this.programJson = this.commonUtil.createNativeMapFromList(programs);
    this.programMap = this.commonUtil.createMapFromList(programs);
    const status = this.data.getValueFromSharedDataMap('AssessmentStatusDesc');
    this.taskStatusJson = this.commonUtil.createNativeMapFromList(status);
    this.statusMap = this.commonUtil.createMapFromList(status);

    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    this.taskDueDates = this.data.getValueFromSharedDataMap('TASKDUEDATES');
    this.taskDueDatesMap = this.commonUtil.createMapFromList(this.taskDueDates);
    // Shared object access to get personId and enrollment
    const sharedData = this.dataService.getSharedDataObject();
    this.changeTaskDueDate();

    if (sharedData.get('etEnrollment') !== null && sharedData.get('etEnrollment') !== undefined) {
      this.enrollment = sharedData.get('etEnrollment');
      this.programCd = this.enrollment.programCd;
    }

    if (sharedData.get('wpPersonId') !== null && sharedData.get('wpPersonId') !== undefined) {
      this.personId = sharedData.get('wpPersonId');
    }    

    if (this.enrollment.id > 0 && this.personId != null) {
      const request = new RequestLoadAll(this.enrollment.id, parseInt(this.personId));
      this.load(request);
    }

    console.log('PersonID ' +  sharedData.get('wpPersonId'));
     
    if (this.personId !== null && this.personId !== undefined) {
      this.loadProviderDetermination(this.personId);
    }      

    this.getColumnDefinitions();
    this.getPdColumnDefinitions();

    //Audit Column Definations Method
    this.getAuditColumnDefinitions();

  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Assessment Start Date',
        field: 'startDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        width: 160,

      },
      {
        headerName: 'Assessment Due Date',
        field: 'dueDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        width: 160,
      },
      {
        headerName: 'Assessment Completed Date',
        field: 'completedDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        width: 200,
      },
      { headerName: 'Assessment Completed By', field: 'modifiedBy', width: 200 },
      {
        headerName: 'Status', field: 'statusCd',
        refData: this.taskStatusJson, width: 130, valueGetter: this.getStatus,
      },
      { headerName: 'Enrollment End Date', field: 'enrollmentEndDt', 
        width: 130  },
      { headerName: 'Action', field: '', cellRenderer: this.getEditButton, width: 120,
        suppressFilter: true,
        suppressSorting: true },

    ];

    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getPdColumnDefinitions() {
    this.pdColumnDefs = [
      {
        headerName: 'Date Determined',
        field: 'dateDetermined',
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        width: 70,

      },
      { headerName: 'Action', field: '', cellRenderer: this.getPdViewButton, width: 60,
        suppressFilter: true,
        suppressSorting: true
      },

    ];

    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getAuditColumnDefinitions() {
    this.auditColumnDefs = [
      {
        headerName: 'Assessment Start Date',
        field: 'startDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Assessment Due Date',
        field: 'dueDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Assessment Status',
        field: 'statusCd',
        refData: this.taskStatusJson,
        width: 130,
        tooltip: (params) => {
          const taskStatusMap = params.context.taskStatusJson;
          const taskStatusCode = params.data.statusCd;
          const taskStatus = taskStatusMap[taskStatusCode];
          return taskStatus;
        }
      },
      { headerName: 'Modified By',
        field: 'createdBy',
        width: 160,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 160,
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getStatus(params) {

    const that = params.context.component;
    return that.statusMap.get(params.data.statusCd);
  }

  getProgram(params) {

    const that = params.context.component;
    return that.programMap.get(params.data.programCd);
  }
  formatDates(params) {
    if (!params.value) {
      return null;
    }

    // //const dateStr = (params.value.split(" "))[0];
    // const dateStr = (params.value.split(" "))[0];
    const dateParts = params.value.split('/');

    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }

    // We create a Date object for comparison against the filter date
    // const dateStr = (cellValue.split(" "))[0];
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }
  getEditButton(params) {
    const that = params.context.component;
    const status = params.data.statusCd;
    if (status === 'CO') {
      that.dataService.addValueToSharedDataMap("assessment-read-only", true);
    }

    const element = document.createElement('a');

    const viewImage = VIEW_BTN ;
    const editImage = EDIT_BTN;
    
    if(params.data.enrollmentEndDt != null && params.data.enrollmentEndDt != undefined && params.data.enrollmentEndDt != "Current"){
      element.innerHTML = viewImage;
    } else {
      element.innerHTML = editImage;
    }


    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap("assessmentId", params.data.id);
      that.dataService.addValueToSharedDataMap('selectedEnrollmentEndDt', params.data.enrollmentEndDt);
      that.router.navigate(['task/assessmentSummary/education']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.dataService.addValueToSharedDataMap("assessmentId", params.data.id);
        that.dataService.addValueToSharedDataMap('selectedEnrollmentEndDt', params.data.enrollmentEndDt);
        that.router.navigate(['task/assessmentSummary/education']);
      }
      else if(event.keyCode == 9){
        event.preventDefault();
        setTimeout(() => deleteElement.focus(), 0);
      }

    });
    element.setAttribute("tabindex", "0");
    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");
    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-3");

    divCol1.appendChild(element);
 
    // Delete Button
    const deleteElement = document.createElement('a');
    if (params.data.statusCd === "CO" || params.data.statusCd === "CN" || that.isDisabled) {
      deleteElement.setAttribute("class", "disabled");
    }

    if(params.data.enrollmentEndDt != null && params.data.enrollmentEndDt != undefined 
        && params.data.enrollmentEndDt != "Current"){
        deleteElement.setAttribute("class", "disabled");
    }

    deleteElement.innerHTML = DELETE_BTN;
    deleteElement.addEventListener('click', () => {
      that.deleteAssessment(params.data.id)
    });

    deleteElement.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.deleteAssessment(params.data.id)
      }
      else if(event.keyCode == 9){
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }
    });

    deleteElement.setAttribute("tabindex", "0");
    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-2");
    divCol2.appendChild(deleteElement);

    
    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Assessment');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Assessment Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory'])
    });
    auditElement.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Assessment');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Assessment Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory'])
      }
    });
    auditElement.setAttribute("tabindex", "0");
    const divCol3 = document.createElement('div');
    divCol3.setAttribute("class", "col-1");
    divCol3.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);
    divRow.appendChild(divCol3);
    return divRow;
  }

  getPdViewButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = VIEW_BTN ;
    element.innerHTML = image;
    element.setAttribute("tabindex","0");

    element.addEventListener('click', () => {
      console.log("params.data.dateDetermined" + params.data.dateDetermined);
      that.dataService.addValueToSharedDataMap('selectedProviderDetermination', params.data);
      that.router.navigate(['/task/assessmentSummary/provider-determination']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        console.log("params.data.dateDetermined" + params.data.dateDetermined);
        that.dataService.addValueToSharedDataMap('selectedProviderDetermination', params.data);
        that.router.navigate(['/task/assessmentSummary/provider-determination']);
      }
      /*else if((!event.shiftKey && event.keyCode===9) && (params.rowIndex === (that.caseNotes.length -1))){
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }*/
    });
    return element;
  }

  getTaskTypeLink(params) {
    const that = params.context.component;
    const taskTypeName = that.convertCode(that.taskTypesMap, params.data.taskType);

    if (params.data.taskStatus === 'IP'
      || params.data.taskStatus === 'OP') {
      const element = document.createElement('a');
      element.innerHTML = taskTypeName;
      element.addEventListener('click', () => {
        that.routeSelection(params.data.taskType, params.data.wpReferral.id, params.data.wpPerson.id, params.data.id);
      });
      return element;
    } else {
      return taskTypeName;
    }
  }

  isAddNewDisabled() {
    return this.addNewDisbaled || this.isDisabled;
  }

  load(request) {
    this.http.post<AssessmentSummaryData[]>(this.serverConstants.SERVER_API_URL + '/assessment-summary/list', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data.length > 0) {
            this.assessments = data;
            this.addNewDisbaled = false;
            this.assessments.forEach(element => {
              if (this.enrollment.id == element.id && (element.statusCd === 'OP' || element.statusCd === 'IP')) {
                this.addNewDisbaled = true;
                this.tabIndex = "0";
              }
            });
          } else {
            this.assessments = [];
            this.noData = true;
          }
        }
      }, response => {
        this.notificationService.error('Assessment Summary', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }

  deleteAssessment(assessmentId) {
     
    const request = new RequestDeleteAssessment(assessmentId, this.enrollment.id, parseInt(this.personId));

    this.http.post<AssessmentSummary[]>(this.serverConstants.SERVER_API_URL + '/assessment-summary/remove', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data.length > 0) {
            this.notificationService.success('Assessment Summary', "Assessment cancelled successfully");
            this.assessments = data;
          } else {
            this.assessments = undefined;
            this.noData = true;
          }
        }
      }, response => {
        this.notificationService.error('Assessment Summary', this.userActionNotificationsMap.ERROR);
      }, () => {
      });
  }

  addEventListenerToSearch(event){
    var tabKeyCode = 9;
    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.assessments.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }
    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusSummary(event) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  addAssessment() {
    let startDt=this.dateUtil.convertDateFromServer(this.dateUtil.getFormattedSystemDateFromModelForServer());

    let dueDt = new Date();
    dueDt=this.addDays(dueDt,30);
    startDt=this.dateUtil.convertDateForServer(startDt);
    this.dataService.removeValueFromSharedDataMap('selectedEnrollmentEndDt');
    //const dueDtStr1=dueDt.getFullYear()+"/"+ (dueDt.getMonth()+1)+"/"+dueDt.getDate();
    const dueDtStr1=this.dateUtil.formatDate(dueDt);
    const request = new AssessmentSummary(this.programCd, this.enrollment.id, 'OP',startDt,dueDtStr1);
    const assessmentRequestVO=new RequestVO(request);

    this.http.post<AssessmentSummary>(this.serverConstants.SERVER_API_URL + '/assessment-summary/save/summary', assessmentRequestVO).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== undefined) {
            this.getWPC();
            this.dataService.addValueToSharedDataMap("assessmentId", data.id);
            this.router.navigate(['task/assessmentSummary/education']);
          }
        }
      }, response => {

        this.notificationService.error('Assessment Summary', this.userActionNotificationsMap.ERROR);
      }, () => {

      });

  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
  getWPC(){
    this.sharedData = this.dataService.getSharedDataObject();
    console.log(this.sharedData.get('personServiceCounty'));
    let ssnValue = this.sharedData.get('SSN_SEARCH');
    let person: WpPerson = new WpPerson();
    person.id = parseInt(this.sharedData.get('wpPersonId'), 10);

    let referral: WpReferral = new WpReferral();
    referral.id = parseInt(this.sharedData.get('referralId'), 10);
    this.task.taskType = "ET";
    this.task.wpPerson = person
    this.task.wpReferral = referral;
    this.task.taskStatus = "OP";
    this.task.assignedTo = this.sharedData.get('personServiceCounty');
    this.task.assignedToInd = "C";
    this.task.programCd = "FS";
    this.task.taskDueDt = this.taskDueDate;
    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetClientWorkParticipation/'
      + ssnValue).subscribe((data)=>{
        if(!data["errorCode"]){
          if(data[0].WORK_PART != "5E"){
            this.http.post<Task>(this.serverConstants.SERVER_API_URL + '/tasks/save', this.task).subscribe((data)=>{
              console.log(data);
              if(!data["errorCode"]){
                this.notificationService.success('E&T Participation task has been Created');
              }
            },error=>{
              console.log(error);
            })
          }
        }
        else{
          this.notificationService.warn('Unable to create E&T Participating task', 'SSN not found in ABAWD group in Eligibility System');
        }
      },error=>{
        this.notificationService.warn('Unable to create E&T Participating task', 'SSN not found in Eligibility System');
      });
  }
  changeTaskDueDate() {
    for (const taskDD of this.taskDueDates) {
      if (taskDD.value == "ET") {
        const taskDueDt = new Date();
        taskDueDt.setDate(taskDueDt.getDate() + Number(taskDD.name));
        const dueDtMonth = (taskDueDt.getMonth() + 1) >= 10 ? '' + (taskDueDt.getMonth() + 1) : '0' + (taskDueDt.getMonth() + 1);
        const taskDueDtStr = (taskDueDt.getFullYear() + '/' + dueDtMonth + '/' + taskDueDt.getDate());
        this.taskDueDate = taskDueDtStr;
        break;
      }
    }
  }


addProviderDetermination() { 
    this.dataService.addValueToSharedDataMap('selectedProviderDetermination', null);       
    this.router.navigate(['task/assessmentSummary/provider-determination']);         
}

loadProviderDetermination(request) {  
    
  this.http.get(this.serverConstants.SERVER_API_URL + '/assessment-summary/providerDetermination/load/' + this.personId).subscribe(
    (data: ProviderDetermination[]) => {
      if (data.hasOwnProperty('errorCode')) {
        this.notificationService.error('Provider Determination', this.userActionNotificationsMap.ERROR);
      } else {
        if (data.length > 0) {
          this.providerDeterminationData = data;
          //this.addNewDisbaled = false;
        } else {
          this.providerDeterminationData = [];
          this.noData = true;
        }
      }
    }, response => {
      this.notificationService.error('Provider Determination', this.userActionNotificationsMap.ERROR);
    }, () => {

    });
}

}

class RequestLoadAll {
  constructor(
    public enrollmentId: Number,
    public personId: Number,
  ) {
  }
}

class RequestLoad {
  constructor(
    public enrollmentId: Number,

  ) {
  }
}

class ProviderDeterminationRequestLoad {
  constructor(
    public personId: Number,

  ) {
  }
}

class RequestDeleteAssessment {
  constructor(
    public id: Number,
    public enrollmentId: Number,
    public personId: Number,
  ) {
  }
}

class RequestDelete {
  constructor(
    public id: Number,
    public enrollmentId: Number,
  ) {
  }
}

class ProviderDetermination {
  constructor(   
    public personId: Number,
    public etEnrollmentId: Number,
    public isIllSuited: string,
    public dateDetermined: any,
    public reasonForDetermination: string,
    public createdBy: string,
    public createdDt: any,
    public lastModifiedBy: string,
    public lastModifiedDt: any 
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/assessment-summary/assessment-summary.component.ts